import { render, staticRenderFns } from "./ServicePromise.vue?vue&type=template&id=78906df5&scoped=true"
import script from "./ServicePromise.vue?vue&type=script&lang=js"
export * from "./ServicePromise.vue?vue&type=script&lang=js"
import style0 from "./ServicePromise.vue?vue&type=style&index=0&id=78906df5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78906df5",
  null
  
)

export default component.exports